// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-1dYTwcMc","list_box":"list_box-27rTGsjm"};